import { getTokenValue } from "../../tamagui-exports";
import { PROMINENT_ROW_MIN_HEIGHT } from "../Selection/SelectionRow";

// The DOM attribute FieldShell stamps on its frame so Dropdown can anchor below it.
export const FIELD_FRAME_ATTR = "data-field-frame";

export const FIELD_FRAME_HEIGHT = "$si7" as const;
// Prominent matches prominent selection rows so a screen mixing both gets one tap-target height.
export const FIELD_FRAME_HEIGHT_PROMINENT = PROMINENT_ROW_MIN_HEIGHT;

export const FIELD_FRAME_PADDING_HORIZONTAL = "$sp2" as const;
export const FIELD_FRAME_PADDING_VERTICAL = 10;
export const FIELD_FRAME_BORDER_WIDTH = "$border2" as const;
export const FIELD_FRAME_BORDER_WIDTH_FOCUSED = "$border3" as const;

// Focus thickens the border; padding gives those pixels back so content doesn't shift.
export const focusedFramePadding = () => {
  const growth =
    Number(getTokenValue(FIELD_FRAME_BORDER_WIDTH_FOCUSED, "space")) -
    Number(getTokenValue(FIELD_FRAME_BORDER_WIDTH, "space"));
  return {
    paddingHorizontal:
      Number(getTokenValue(FIELD_FRAME_PADDING_HORIZONTAL, "space")) - growth,
    paddingVertical: FIELD_FRAME_PADDING_VERTICAL - growth,
  };
};
